import React from "react";
import "./Support.css";
import HeroSection from "../HeroSection";
import Offer from "../Offer";
import Newsletter from "../Newsletter";
import Footer from "../Footer";
import donateIcon from "./assets/svg/donate.svg";
import volunteerIcon from "./assets/svg/volunteer.svg";
import partnerIcon from "./assets/svg/partner.svg";
import whyImage from "./assets/support.jpg";

export default function Support() {
  return (
    <main className="support-page">
      <HeroSection
        title="Segíts, hogy még több embernek adhassunk hangot!"
        text={
          <>
            A dadogás sokak számára láthatatlan küzdelem — de nem kell egyedül
            megélniük. Egyesületünk nap mint nap azon dolgozik, hogy:
            <ul
              style={{
                marginTop: "1rem",
                marginBottom: "1rem",
                paddingLeft: "1.5rem",
              }}
            >
              <li>támogató közösséget teremtsünk</li>
              <li>elérhető logopédiai és önsegítő programokat biztosítsunk</li>
              <li>lebontsuk a dadogással kapcsolatos tévhiteket</li>
              <li>erősítsük az önbizalmat minden érintettben</li>
            </ul>
          </>
        }
      />

      <section className="support-how">
        <div className="support-how-container">
          <h2 className="heading-lg">Hogyan segíthetsz?</h2>

          <p>
            Csatlakozz hozzánk bármilyen formában — minden támogatás közelebb
            visz minket ahhoz, hogy még több embernek adhassunk hangot.
          </p>

          <div className="support-options">
            <div className="support-card">
              <img src={donateIcon} alt="Adományozás ikon" />

              <h3 className="heading-md">Adományozz</h3>

              <p>
                Minden felajánlott összeg közvetlenül programjaink és segítő
                tevékenységeink fenntartására megy.
              </p>

              <p className="support-info">
                <strong>Kedvezményezett:</strong> BESZÉLJ! EGYESÜLET
                <br />
                <strong>Számlaszám:</strong> 11600006-00000002-01653850
                <br />
                <strong>Közlemény:</strong> A nevet kérjük feltüntetni!
              </p>
            </div>

            <div className="support-card">
              <img src={volunteerIcon} alt="Önkéntes ikon" />

              <h3 className="heading-md">Legyél önkéntes</h3>

              <p>
                Csatlakozz hozzánk! Önkénteseink nélkül nem tudnánk eljutni
                ennyi emberhez.
              </p>

              <p className="support-info">
                Írj nekünk:{" "}
                <a href="mailto:elnokseg@beszeljegyesulet.hu">
                  elnokseg@beszeljegyesulet.hu
                </a>
              </p>
            </div>

            <div className="support-card">
              <img src={partnerIcon} alt="Partner ikon" />

              <h3 className="heading-md">Partnerként támogass</h3>

              <p>
                Ha céged szívesen állna mellénk, örömmel alakítunk ki
                együttműködést.
              </p>

              <p className="support-info">
                Írj nekünk:{" "}
                <a href="mailto:elnokseg@beszeljegyesulet.hu">
                  elnokseg@beszeljegyesulet.hu
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="support-why">
        <div className="support-why-container">
          <div
            className="why-image"
            style={{ backgroundImage: `url(${whyImage})` }}
          />

          <div className="why-right heading-md">
            <h2>Miért számít minden segítség?</h2>

            <p>
              Magyarországon limitált az emberek tudása a dadogásról, és mi
              azért vagyunk, hogy minél több embernek bátorítást és tudást
              nyújtsunk.
            </p>

            <p>
              Minden támogatás – legyen az pénzbeli, idő vagy szakértelem –
              életeket változtat meg.
            </p>

            <p>
              Te is részese lehetsz annak, hogy valaki újra merjen beszélni,
              kiállni, önmagát adni.
            </p>
          </div>
        </div>
      </section>

      <Offer />
      <Newsletter twoColumn={true} />
      <Footer />
    </main>
  );
}